// К сожалению, честный способ получения названия полей из валидаторов потребует полной переделки
// Поэтому имеет место такой костыль

import { ZAttribute } from "src/types/ZAttribute";
import { ZUid } from "src/types/zUid";

export const attrInfoMap: Record<ZUid, ZAttribute> = {};

export const updateAttrInfoMap = (attrList: ZAttribute[]) => {
  attrList.forEach((a) => {
    attrInfoMap[a.id] = a;
  });
};

export const getAttrNameById = (attrId: ZUid): string =>
  attrInfoMap[attrId]?.name ?? `Attr ${attrId}`;
